import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-tagged-text',
  standalone: false,
  templateUrl: './liberro-tagged-text.component.html',
  styleUrl: './liberro-tagged-text.component.less'
})
export class LiberroTaggedTextComponent {
  @Input() public type: 'success' | 'danger' | 'grey' = 'success';

}
